// hooks/Planpage/useSubscriptions.js
import { useState, useEffect } from 'react';
import { fetchSubscriptions, fetchAddOns } from '../../api/planpage';

export const useSubscriptions = () => {
  const [workoutPlans, setWorkoutPlans] = useState([]);
  const [dietPlans, setDietPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadPlans = async () => {
      try {
        const [workouts, diets] = await Promise.all([
          fetchSubscriptions(),
          fetchAddOns()
        ]);
        setWorkoutPlans(workouts);
        setDietPlans(diets);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadPlans();
  }, []);

  return { workoutPlans, dietPlans, loading, error };
};